import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import looppa from 'looppa';
import PropTypes from 'prop-types';
import slideDown from './slide-down';
import slideRight from './slide-right';
import slideLeft from './slide-left';

export default class Animation extends Component {
    static defaultProps = {
        animation: 'slideDown',
        animationConfig: null,
        duration: 200,
        easing: 'cubic-bezier(0.25, 0.1, 0.75, 1)',
    };

    static propTypes = {
        children: PropTypes.any.isRequired,
        animation: PropTypes.string,
        animationConfig: PropTypes.object,
        duration: PropTypes.number,
        easing: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.animations['slideDown'] = slideDown;
        this.animations['slideRight'] = slideRight;
        this.animations['slideLeft'] = slideLeft;
    }

    animations = {};

    getAnimation() {
        if (this.props.animationConfig) {
            return this.props.animationConfig;
        }

        const { animation } = this.props;
        if (!this.animations[animation]) {
            console.warn(`No animation named ${ animation } found`);
        }

        return this.animations[animation];
    }

    render() {
        const { children, duration, easing } = this.props;
        const animation = this.getAnimation();

        return (
            <FlipMove
                duration={ duration }
                easing={ easing }
                appearAnimation={ animation.in }
                enterAnimation={ animation.in }
                leaveAnimation={ animation.out }
            >
                { Array.isArray(children) ? looppa(children)((child) => (
                    { child }
                )) : children }
            </FlipMove>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/animations/index.js